export default function Footer() {
  return (
    <footer className="bg-[#F0FBF8] border-t border-gray-100 pt-12 md:pt-16 pb-8 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-10 md:mb-12">

          {/* Column 1 */}
          <div>
            <img
              src="https://i.ibb.co/G4Wc9Knk/sweetplate-logo.png"
              alt="Sweet Plate"
              className="h-10 md:h-12 w-auto object-contain mb-3 md:mb-4"
            />
            <p className="text-sm text-gray-500 leading-relaxed max-w-xs">
              The future of taste, trust &amp; technology. Delivering joy to your doorstep.
            </p>
          </div>

          {/* Column 2 */}
          <div>
            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">
              Let&apos;s do it together
            </h3>
            <ul className="space-y-2.5">
              {[
                { label: 'Become a rider', href: 'https://sweetplate.org/sweetplateDriver.apk' },
                { label: 'Become a Vendor', href: 'https://merchant.sweetplate.org/' },
                { label: 'Community', href: 'https://t.me/sweetplate' },
                { label: 'Instagram', href: 'https://www.instagram.com/sweetplatedelivery?igsh=M3FvNDQzbTh4eWY1&utm_source=qr' },
                
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.href !== '#' ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    className="text-sm text-gray-500 hover:text-[#009E81] transition-colors cursor-pointer"
                  >
                    — {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wider mb-4">
              Links of interest
            </h3>
            <ul className="space-y-2.5 mb-5 md:mb-6">
              {[
                { label: 'About us', href: '/about' },
                { label: 'info@sweetplate.org', href: 'mailto:info@sweetplate.org' },
                // { label: 'Terms & Conditions', href: '#' },
                // { label: 'Privacy Policy', href: '#' },
                // { label: 'Cookies Policy', href: '#' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.href.startsWith('http') ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    className="text-sm text-gray-500 hover:text-[#009E81] transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="flex items-center gap-3 flex-wrap">
              <a
                href="https://play.google.com/store/apps/details?id=com.sweetplate.user"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity cursor-pointer"
              >
                <img
                  src="https://glovoapp.com/_next/static/media/google-button.4b60c502.svg"
                  alt="Google Play"
                  className="h-12 md:h-14 w-auto"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-200 pt-5 md:pt-6 flex flex-col md:flex-row items-center md:justify-between gap-3">
          <p className="text-xs text-gray-400 text-center md:text-left">
            &copy; {new Date().getFullYear()} Sweet Plates Deliveries Limited. All rights reserved.
          </p>
          <select className="text-xs text-gray-500 bg-transparent border border-gray-200 rounded-lg px-2 py-1 cursor-pointer outline-none">
            <option value="en">English</option>
            <option value="fr">Français</option>
            <option value="es">Español</option>
            <option value="pt">Português</option>
            <option value="ru">Русский</option>
          </select>
        </div>
      </div>
    </footer>
  );
}
